import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent {

    static componentName = 'ContentComponent';
    @Input()contentString: String;

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/content/content.component.ts